import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Flutter = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="m3 11.987 3.146 3.142L19.37 2h-6.295L3 11.987ZM14.519 17.259l4.669 4.74h-6.242l-1.561-1.624 3.134-3.116ZM10.696 19.721l-3.142-3.142 5.417-5.396h6.283l-8.558 8.538Z"
      fill="currentColor"
    />
  </Icon>
));

export default Flutter;
